import types from "../types/types";

const initialState = {
	/** Company / role-scoped list for dashboard stats, logs, wages widgets */
	clockings: undefined,
	/** Signed-in employee only — unblocks Veprime Turni without waiting on admin bulk */
	myClockings: undefined,
	myEmployeeId: null,
};

function upsertClocking(array, objectToReplace) {
	if (!Array.isArray(array)) return array;
	let replaced = false;
	const next = array.map((item) => {
		if (item?.clockingId === objectToReplace?.clockingId) {
			replaced = true;
			return objectToReplace;
		}
		return item;
	});
	if (!replaced && objectToReplace) next.push(objectToReplace);
	return next;
}

const clockingsReducer = (state = initialState, action) => {
	const { type, payload } = action;

	switch (type) {
		case types.SET_CLOCKINGS:
			return {
				...state,
				clockings: payload,
			};
		case types.SET_MY_CLOCKINGS:
			return {
				...state,
				myClockings: Array.isArray(payload?.rows) ? payload.rows : [],
				myEmployeeId: payload?.employeeId || null,
			};
		case types.ADD_CLOCKING: {
			const next = { ...state };
			if (Array.isArray(state.clockings)) {
				next.clockings = upsertClocking(state.clockings, payload);
			}
			if (
				Array.isArray(state.myClockings) &&
				state.myEmployeeId &&
				payload?.employeeId === state.myEmployeeId
			) {
				next.myClockings = upsertClocking(state.myClockings, payload);
			}
			return next;
		}
		case types.EDIT_CLOCKING: {
			const next = { ...state };
			if (Array.isArray(state.clockings)) {
				next.clockings = upsertClocking(state.clockings, payload);
			}
			if (
				Array.isArray(state.myClockings) &&
				(!state.myEmployeeId ||
					payload?.employeeId === state.myEmployeeId)
			) {
				next.myClockings = upsertClocking(state.myClockings, payload);
			}
			return next;
		}
		default:
			return state;
	}
};

export default clockingsReducer;
